import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class AiResponse extends BasicEntity {
aiUid: string;
crc: string;
error: string;
externalID: string;
hasError: boolean;
kind: string;
language: string;
prompt: Object | string;
questionCode: string;
response: string;
visionCode: string;
}

